export const gray = "#1c1c1c";
export const lightGray = "#585858";
export const lightBlueGray = "#EDF3F7";
export const darkCerulean = "#2d5889";
